<template>
	<div style="width: 100%;height: 100%;">
		<div style="width:98%;margin-left: 1%;margin-top:1.5%;height:95%;background-color: white;box-shadow:#e0e0e0 5px 5px 10px;">
			<div style="width:95%;height:96%;padding:2%;display: flex;flex-direction: column;">
			
				<div style="width:100%;display: flex;flex-direction: row;align-items: center;height:3vh;margin-bottom: 2vh;"
				
				>	
                    <div style="height: 35px;width:120px;border-radius: 5px;display: flex;align-items: center;justify-content: center;margin-right: 10px;"
                    :style="{backgroundColor:type==0?'#3c9cff':'#d9ecff',color:type==0?'white':'#409eff'}" @click="show=true"
                    >
                        {{ "添加公告信息" }}
                    </div>
				</div>

				<div style="height: auto;flex:1;" >
				<el-table
					height="80vh"
				    :data="list"
					border
				    style="width: 100%"
					>
                    <el-table-column
				      prop="title"
				      label="公告标题"
				      >
				    </el-table-column>
                    <el-table-column
				      prop="data"
				      label="公告内容"
				      >
				    </el-table-column>
                    <el-table-column
				       prop="author"
				      label="发布人">
				    </el-table-column>
                    <el-table-column
				       prop="time"
				      label="发布日期">
				    </el-table-column>
					<el-table-column
				      label="是否置顶"
				      width="100">
                        <template slot-scope="scope">
							<div v-if="scope.row.top==0">{{'否'}}</div>
                            <div v-if="scope.row.top==1">{{'是'}}</div>
					    </template>
				    </el-table-column>
                    <el-table-column
					      fixed="right"
					      label="操作"
						  width="180"
					      >
					      <template slot-scope="scope">
                            <el-button @click="updategift1(scope.row)" type="text" size="small">编辑</el-button>
							<el-button @click="deletevideo(scope.row)" type="text" size="small">删除</el-button>
					      </template>
					</el-table-column>
				  </el-table>
				</div>
			</div>
		</div>
        
         <el-dialog
        title="发布公告信息"
        :visible.sync="show"
        width="30%;"
        style="z-index: 9999;"
        >

            <el-form ref="newnotice" :model="newnotice" label-width="80px">
                <el-form-item label="公告标题">
                    <el-input v-model="newnotice.title"></el-input>
                </el-form-item>
                <el-form-item label="公告内容">
                    <el-input type="textarea" v-model="newnotice.data"></el-input>
                </el-form-item>
                <el-form-item label="发布人">
                    <el-input v-model="newnotice.author"></el-input>
                </el-form-item>
                 <el-form-item label="是否顶置">
                    <el-radio-group v-model="newnotice.top">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onsubmit">保存</el-button>
                    <el-button @click="show1=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
       
              

        <el-dialog
        title="修改公告信息"
        :visible.sync="show1"
        width="30%;"
        style="z-index: 9999;"
        >

            <el-form ref="newgift" :model="updatenotice" label-width="80px">
                <el-form-item label="公告标题">
                    <el-input v-model="updatenotice.title"></el-input>
                </el-form-item>
                <el-form-item label="公告内容">
                    <el-input type="textarea" v-model="updatenotice.data"></el-input>
                </el-form-item>
                <el-form-item label="发布人">
                    <el-input v-model="updatenotice.author"></el-input>
                </el-form-item>
                 <el-form-item label="是否顶置">
                    <el-radio-group v-model="updatenotice.top">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onchange">保存</el-button>
                    <el-button @click="show1=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
		
		
		
	</div>
</template>

<script>
import {post,get} from "../axios/request.js"
export default {
  name:"order",
  data() {
    return {
       filelist:[],
       filelist1:[],
       list:[],
       type:0,
       show:false,
       show1:false,
       newnotice:{
        data:"",
        title:"",
        time:"",
        author:"",
        top:0
       },
       updatenotice:{
        data:"",
        title:"",
        time:"",
        author:"",
        top:0
       }
       
    }
  },
  mounted() {
	this.getmore();
  },
  methods: {
	getmore(){
		post("/api/getnotice",{}).then((res)=>{
			if(res.data.code==1001){
                this.list=res.data.data.reverse();
            }
		})
	},
    updategift1(e){
        this.updatenotice=e;
        this.show1=true
    },
    onchange(){
        if(this.updatenotice.title==''){
            this.$message.error("请填写公告标题")
            return;
        }
        if(this.updatenotice.data==''){
            this.$message.error("请填写公告内容")
            return;
        }
        if(this.updatenotice.authro==''){
            this.$message.error("请填写发送人名称")
            return;
        }
        post("/api/updatenotice",this.updatenotice).then((res)=>{
            if(res.data.code==1001){
                this.$notify({
                    title: '提交成功',
                    message: '已添加公告:'+this.updatenotice.title,
                    type: 'success'
                });
                this.show1=false;
                this.updatenotice={
                    data:"",
                    title:"",
                    author:"",
                    top:0,
                    time:""
                }
                this.getmore()
            }else{
                 this.$notify({
                    title: '系统错误',
                    type: 'error'
                });
            }
        })
    },
    onsubmit(){
        if(this.newnotice.title==''){
            this.$message.error("请填写公告标题")
            return;
        }
        if(this.newnotice.data==''){
            this.$message.error("请填写公告内容")
            return;
        }
        if(this.newnotice.authro==''){
            this.$message.error("请填写发送人名称")
            return;
        }
        this.newnotice.time=this.getCurrentTime();
        post("/api/newnotice",this.newnotice).then((res)=>{
            if(res.data.code==1001){
                this.$notify({
                    title: '提交成功',
                    message: '已添加公告:'+this.newnotice.title,
                    type: 'success'
                });
                this.show=false;
                this.newnotice={
                    data:"",
                    title:"",
                    author:"",
                    top:0,
                    time:""
                }
                this.getmore()
            }else{
                 this.$notify({
                    title: '系统错误',
                    type: 'error'
                });
            }
        })
    },
    getCurrentTime() {
      const now = new Date();
      // 分别获取年、月、日、时、分、秒
      const year = now.getFullYear();
      // 月份需要 +1（因为 getMonth() 返回 0-11）
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      // 拼接成指定格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    deletevideo(e){
        this.$confirm('是否删除公告:'+e.title, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          post("/api/deletenotice",{id:e.id}).then((res)=>{
			if(res.data.code==1001){
                this.$notify({
                    title: '删除成功',
                    type: 'success'
                });
                this.getmore()
            }else{
                this.$notify({
                    title: '错误',
                    video: '未知的系统错误',
                    type: 'error'
                });
            }
		})
        }).catch(() => {
                
        });
        
    }
  }
}
</script>
<style scoped>
::v-deep .isdisabled  {
	background-color: white;
}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>